module.exports = __webpack_public_path__ + "img/BNT.8503400b.svg";